import { HttpResponseBase } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ClientInterceptor } from '@unity/lib/unity/clientBase';
import { ErrorService } from '@unity/services/error.service';
import { catchError, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ApiErrorInterceptor implements ClientInterceptor {
  private readonly errorService = inject(ErrorService);

  public transformResult(_response: HttpResponseBase, response$: Observable<unknown>): Observable<unknown> {
    return response$.pipe(catchError(this.errorService.handleApiException));
  }
}
